import React from "react";
import { FormattedMessage } from "react-intl";
import moment from "moment";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { VaporDatePicker } from "../../../vapor";
import { Tooltip } from "antd";

/**
 * Fields for asset assignment and revocation in drawer footer
 * This is an array components
 * @returns
 */
const ActivationDisactivationDrawerFields = ({ editable, setEditable, setModifiedFields, modifiedFields, readOnly=false, setFieldsToDelete}) => {
  const dateFormatList = ["DD/MM/YYYY", "DD/MM/YY", "DD-MM-YYYY", "DD-MM-YY", "DDMMYYYY", "DDMMYY"];
  
  return (
    <>
      <div className="pre-cog-assets-drawer-titles">
        <FormattedMessage id={"preCog.assetsTab.drawer.availabilityAndDeducibility"} />
      </div>
      <div data-testid="ActivationDisactivationDrawerFields" className="pre-cog-assets-drawer-section" style={{flexDirection: "row"}}>
        <div style={{width: "26%"}}>
          <div>
            <div className="precog-withholding-drawer-form—label-text" style={{ display: "flex", alignItems: "center" }}>
              <FormattedMessage id={"preCog.assetsTab.drawer.activationDate"} />
              <div className="precog-withholding-drawer-form—label-tooltip">
                <Tooltip
                  color={"rgb(0, 80, 117)"}
                  placement="top"
                  title={<FormattedMessage
                    id={"preCog.assetsTab.tooltips.activationDate"}
                  />}>
                  <FontAwesomeIcon icon={("fas", "info-circle")} />
                </Tooltip>
              </div>
            </div>
            <VaporDatePicker
              disabled={readOnly}
              value={editable.activationDate ? moment(editable.activationDate) : undefined}
              onChange={e => {
                setEditable({ ...editable, activationDate: e });
                if (e) {
                  setModifiedFields({ ...modifiedFields, activationDate: e });
                } else {
                  setFieldsToDelete(["activationDate"]);
                }
              }}
              format={dateFormatList}
              allowClear
              getPopupContainer={(trigger) => trigger.parentNode}
              disabledDate={current => current > moment(editable?.suspensionDate) || current > modifiedFields?.suspensionDate }
            />
          </div>
        </div>
        <div style={{width: "26%"}}>
          <div>
            <div className="precog-withholding-drawer-form—label-text" style={{ display: "flex", alignItems: "center" }}>
              <FormattedMessage id={"preCog.assetsTab.drawer.suspensionDate"} />
              <div className="precog-withholding-drawer-form—label-tooltip">
                <Tooltip
                  color={"rgb(0, 80, 117)"}
                  placement="top"
                  title={<FormattedMessage
                    id={"preCog.assetsTab.tooltips.suspensionDate"}
                  />}>
                  <FontAwesomeIcon icon={("fas", "info-circle")} />
                </Tooltip>
              </div>
            </div>
            <VaporDatePicker
              format={dateFormatList}
              disabled={readOnly}
              value={editable.suspensionDate ? moment(editable.suspensionDate) : undefined}
              allowClear
              onChange={e => {
                setEditable({ ...editable, suspensionDate: e });
                if (e) {
                  setModifiedFields({ ...modifiedFields, suspensionDate: e });
                } else {
                  setFieldsToDelete(["suspensionDate"]);
                }
              }}
              getPopupContainer={(trigger) => trigger.parentNode}
              disabledDate={current => current < moment(editable?.activationDate) || current < modifiedFields?.activationDate }
            />
          </div>
        </div>
        <div className="pre-cog-assets-drawer-hr-vertical">&nbsp;</div>
        <div style={{width: "38%"}}>
          <div>
            <div className="precog-withholding-drawer-form—label-text" style={{ display: "flex", alignItems: "center" }}>
              <FormattedMessage id={"preCog.assetsTab.drawer.availabilityDate"} />
              <div className="precog-withholding-drawer-form—label-tooltip">
                <Tooltip
                  color={"rgb(0, 80, 117)"}
                  placement="top"
                  title={<FormattedMessage
                    id={"preCog.assetsTab.tooltips.availabilityDate"}
                  />}>
                  <FontAwesomeIcon icon={("fas", "info-circle")} />
                </Tooltip>
              </div>
            </div>
            <VaporDatePicker
              format={dateFormatList}
              disabled={readOnly}
              value={editable.availabilityDate ? moment(editable.availabilityDate) : undefined}
              allowClear
              onChange={e => {
                setEditable({ ...editable, availabilityDate: e });
                if (e) {
                  setModifiedFields({ ...modifiedFields, availabilityDate: e });
                } else {
                  setFieldsToDelete(["availabilityDate"]);
                }
              }}
              getPopupContainer={(trigger) => trigger.parentNode}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default ActivationDisactivationDrawerFields;
